import type { RecordObject } from "@/profitability/records/objects";
import type { ReportRow } from "@/profitability/types";
import { SourceButton } from "./source-button";
import { useRecordSource } from "./use-record-source";

/**
 * A record table row's "Source" button, in its name cell: it opens the
 * record's figures beside the file they were read from. Nothing where the
 * page offers no source, or the record's dataset has none.
 */
export const RowSourceButton = ({
  object,
  row,
  label,
}: {
  object: RecordObject;
  row: ReportRow;
  /** The record's words: "Job 48217". */
  label: string;
}) => {
  const show = useRecordSource(object, row);
  if (!show) return null;
  return (
    <SourceButton
      label={`Show where ${label}'s figures come from`}
      onClick={() => show()}
      className="-my-1"
    />
  );
};
